@if (isVisible) {
  <div class="mobile-app-prompt">
    <div class="mobile-app-prompt__card" role="dialog" aria-modal="true" aria-labelledby="mobile-app-prompt-title">
      <img class="mobile-app-prompt__logo" src="assets/images/default/logo-isofarm.svg" alt="isoFarm" />
      <h2 id="mobile-app-prompt-title" class="mobile-app-prompt__title">
        {{ 'mobile-app-prompt.title' | translate }}
      </h2>
      <p class="mobile-app-prompt__text">
        {{ 'mobile-app-prompt.description' | translate }}
      </p>
      <div class="mobile-app-prompt__actions">
        <button class="mobile-app-prompt__btn mobile-app-prompt__btn--primary" type="button" (click)="downloadApp()">
          {{ downloadLabelKey | translate }}
        </button>
        <button
          class="mobile-app-prompt__btn mobile-app-prompt__btn--secondary"
          type="button"
          (click)="continueOnWeb()">
          {{ 'mobile-app-prompt.continue-web' | translate }}
        </button>
      </div>
    </div>
  </div>
}
